import { all } from 'redux-saga/effects';
import openPositionsSaga from './saga';
import topFetchSagas from './homeSaga';
import initAppSagas from './initAppSaga';

export default function* rootSaga() {
    yield all([
        openPositionsSaga(),
        topFetchSagas(),
        initAppSagas(),
    ])
}